export const VIEW_TOP_MARGIN = 50;
export const VIEW_LEFT_MARGIN = 10;
export const FULLSCREEN_VIEW_TOP_MARGIN = 30;
export const MARGIN_FOR_SCROLLBAR = 20;
export const SCROLLBAR_OFFSET_CHANGING_PAGE = 20;
export const PAGE_STROKE_WIDTH = 2;
export const IMAGE_ZONE_STROKE_WIDTH = 1;
export const KEY_SCROLL_DISTANSE = 20;
export const IMAGE_OBJECT_NAME = 'image';
